/* /pages/review - drives templates/page.review.liquid against the ssc-account Worker. */
(function () {
  var root = document.getElementById('ssc-review');
  if (!root) return;
  var WORKER = root.getAttribute('data-worker');
  var MAX_PHOTOS = 3;
  var MAX_EDGE = 1800;
  var STAR_LABELS = ['', 'Poor', 'Below expectations', 'OK', 'Good', 'Excellent'];
  var ERRORS = {
    bad_request: 'Check the order number and email and try again.',
    no_match: 'We could not find an order with that number and email. Use the email you ordered with.',
    cancelled: 'That order was cancelled, so there is nothing to review.',
    not_in_order: 'That product is not in this order.',
    already_reviewed: 'You have already reviewed this product from this order. Thank you!',
    rate_limited: 'Too many tries in a short time. Wait a few minutes and try again.',
    upstream: 'Something went wrong on our side. Please try again in a minute.'
  };

  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };
  var state = { order: '', email: '', data: null, product: null, photos: [] };

  function show(step) {
    $$('.sr-step').forEach(function (s) { s.hidden = s.getAttribute('data-step') !== String(step); });
    $$('.sr-steps li').forEach(function (li, i) {
      // sidebar: 1 find order, 2 pick + write (form steps 2 and 3), 3 credit (thank-you step)
      var n = step === 1 ? 0 : step < 4 ? 1 : 2;
      li.classList.toggle('is-active', i === n);
      li.classList.toggle('is-done', i < n);
    });
    globalError('');
    if (step > 1) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function globalError(msg) { var el = $('.sr-global'); el.textContent = msg; el.hidden = !msg; }
  function busy(on) { root.classList.toggle('sr-busy', on); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(src, w) { return src ? src.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2') : ''; }

  function post(path, body, isForm) {
    return fetch(WORKER + path, {
      method: 'POST',
      headers: isForm ? undefined : { 'Content-Type': 'application/json' },
      body: isForm ? body : JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return { error: 'upstream' }; }).then(function (data) { data._status = res.status; return data; });
    }).catch(function () { return { error: 'upstream', _status: 0 }; });
  }

  // Step 1
  var lookupForm = $('.sr-lookup');
  var params = new URLSearchParams(location.search);
  if (params.get('order')) lookupForm.order.value = params.get('order').replace(/[^0-9]/g, '');

  lookupForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var order = lookupForm.order.value.replace(/[^0-9]/g, '');
    var email = lookupForm.email.value.trim();
    if (!order || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return globalError(ERRORS.bad_request);
    busy(true);
    post('/review/lookup', { order: order, email: email }).then(function (data) {
      busy(false);
      if (data.error) return globalError(ERRORS[data.error] || ERRORS.upstream);
      state.order = order; state.email = email; state.data = data;
      renderProducts();
      show(2);
    });
  });

  // Step 2
  function renderProducts() {
    var d = state.data;
    $('[data-sr="order-name"]').textContent = 'Order ' + d.order;
    var wrap = $('.sr-products');
    wrap.innerHTML = d.items.map(function (it, i) {
      return '<button type="button" class="sr-product" data-i="' + i + '"' + (it.reviewed ? ' disabled' : '') + '>' +
        (it.image ? '<img src="' + esc(img(it.image, 400)) + '" alt="" loading="lazy">' : '<span class="sr-noimg"></span>') +
        '<b>' + esc(it.title) + '</b>' + (it.variant && it.variant !== 'Default Title' ? '<small>' + esc(it.variant) + '</small>' : '') +
        '<span class="sr-tag">' + (it.reviewed ? 'Reviewed' : 'Review this') + '</span></button>';
    }).join('');
    $$('.sr-product', wrap).forEach(function (b) {
      b.addEventListener('click', function () { choose(d.items[Number(b.getAttribute('data-i'))]); });
    });
    var open = d.items.filter(function (it) { return !it.reviewed; });
    if (d.items.length && !open.length) globalError('Every product in this order already has your review. Thank you!');
    if (open.length === 1 && d.items.length === 1) choose(open[0]);
  }

  // Step 3
  var form = $('.sr-review');
  function choose(item) {
    state.product = item;
    $('[data-sr="chosen"]').innerHTML = (item.image ? '<img src="' + esc(img(item.image, 160)) + '" alt="">' : '') +
      '<div><b>' + esc(item.title) + '</b><small>' + esc(state.data.order) + '</small></div>';
    if (!form.name.value && state.data.firstName) form.name.value = state.data.firstName + (state.data.lastInitial ? ' ' + state.data.lastInitial + '.' : '');
    if (!form.location.value && (state.data.city || state.data.country)) form.location.value = [state.data.city, state.data.country].filter(Boolean).join(', ');
    show(3);
  }
  $('[data-sr="change-product"]').addEventListener('click', function () { show(2); });

  var starLabels = $$('.sr-stars label');
  function paintStars(n) { starLabels.forEach(function (l, i) { l.classList.toggle('is-on', i < n); }); $('[data-sr="star-label"]').textContent = n ? STAR_LABELS[n] : 'Tap a star'; }
  function checkedStars() { var c = $('.sr-stars input:checked'); return c ? Number(c.value) : 0; }
  starLabels.forEach(function (l, i) {
    l.addEventListener('mouseenter', function () { paintStars(i + 1); });
    l.querySelector('input').addEventListener('change', function () { paintStars(checkedStars()); setErr('rating', ''); });
  });
  $('.sr-stars').addEventListener('mouseleave', function () { paintStars(checkedStars()); });

  var countEl = $('[data-sr="count"]');
  form.body.addEventListener('input', function () {
    var n = form.body.value.trim().length;
    countEl.textContent = n;
    countEl.parentNode.classList.toggle('is-ok', n >= 60);
  });

  // Photos: downscale in the browser so phone shots upload fast and stay under the limit.
  var picker = form.photosPicker;
  picker.addEventListener('change', function () {
    var files = Array.prototype.slice.call(picker.files || []);
    picker.value = '';
    setErr('photos', '');
    files.slice(0, MAX_PHOTOS - state.photos.length).forEach(function (f) {
      if (!/^image\/(jpeg|png|webp|heic|heif)$/i.test(f.type) && !/\.(jpe?g|png|webp|heic)$/i.test(f.name)) return setErr('photos', 'Photos must be JPG, PNG or WebP.');
      shrink(f).then(function (blob) {
        if (state.photos.length >= MAX_PHOTOS) return;
        state.photos.push(blob); renderThumbs();
      }).catch(function () { setErr('photos', 'We could not read ' + f.name + '. Try a JPG.'); });
    });
  });
  function shrink(file) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var im = new Image();
      im.onload = function () {
        var s = Math.min(1, MAX_EDGE / Math.max(im.naturalWidth, im.naturalHeight));
        var c = document.createElement('canvas');
        c.width = Math.round(im.naturalWidth * s); c.height = Math.round(im.naturalHeight * s);
        c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        c.toBlob(function (b) { b ? resolve(b) : reject(); }, 'image/jpeg', 0.86);
      };
      im.onerror = function () { URL.revokeObjectURL(url); reject(); };
      im.src = url;
    });
  }
  function renderThumbs() {
    var t = $('[data-sr="thumbs"]');
    t.innerHTML = '';
    state.photos.forEach(function (b, i) {
      var d = document.createElement('div'); d.className = 'sr-thumb';
      d.innerHTML = '<img alt=""><button type="button" aria-label="Remove photo">&times;</button>';
      d.querySelector('img').src = URL.createObjectURL(b);
      d.querySelector('button').addEventListener('click', function () { state.photos.splice(i, 1); renderThumbs(); });
      t.appendChild(d);
    });
    $('.sr-drop').classList.toggle('is-full', state.photos.length >= MAX_PHOTOS);
  }

  function setErr(key, msg) { var el = $('[data-err="' + key + '"]'); if (el) el.textContent = msg || ''; }
  function validate() {
    var errs = {};
    if (!checkedStars()) errs.rating = 'Pick 1 to 5 stars.';
    if (form.title.value.trim().length < 3) errs.title = 'Give the review a short headline.';
    if (form.body.value.trim().length < 60) errs.body = 'Write at least 60 characters, a few sentences is plenty.';
    if (form.name.value.trim().length < 2) errs.name = 'Tell us the name to show.';
    if (!form.consentPublish.checked) errs.consentPublish = 'We need your OK to publish the review.';
    return errs;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    ['rating', 'title', 'body', 'name', 'consentPublish', 'photos'].forEach(function (k) { setErr(k, ''); });
    var errs = validate();
    var keys = Object.keys(errs);
    if (keys.length) {
      keys.forEach(function (k) { setErr(k, errs[k]); });
      var first = $('[data-err="' + keys[0] + '"]');
      if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    var fd = new FormData();
    fd.append('order', state.order);
    fd.append('email', state.email);
    fd.append('productId', state.product.productId);
    fd.append('rating', String(checkedStars()));
    ['title', 'body', 'name', 'location', 'cook', 'howLong', 'useFor', 'instagram'].forEach(function (k) { fd.append(k, form[k].value.trim()); });
    ['consentPublish', 'consentPhotos', 'consentContact'].forEach(function (k) { if (form[k].checked) fd.append(k, 'yes'); });
    state.photos.forEach(function (b, i) { fd.append('photos', b, 'photo-' + (i + 1) + '.jpg'); });

    var errBox = $('.sr-review .sr-error');
    errBox.hidden = true;
    busy(true);
    post('/review/submit', fd, true).then(function (data) {
      busy(false);
      if (data.error === 'invalid' && data.errors) { Object.keys(data.errors).forEach(function (k) { setErr(k, data.errors[k]); }); return; }
      if (data.error) { errBox.textContent = ERRORS[data.error] || ERRORS.upstream; errBox.hidden = false; return; }
      state.product.reviewed = true;
      $('[data-sr="done-email"]').textContent = state.email;
      $('[data-sr="another"]').hidden = !state.data.items.some(function (it) { return !it.reviewed; });
      show(4);
    });
  });

  $('[data-sr="another"]').addEventListener('click', function () {
    ['title', 'body', 'useFor'].forEach(function (k) { form[k].value = ''; });
    $$('.sr-stars input').forEach(function (i) { i.checked = false; });
    paintStars(0); countEl.textContent = '0'; countEl.parentNode.classList.remove('is-ok');
    state.photos = []; renderThumbs();
    form.consentPublish.checked = false;
    renderProducts();
    show(2);
  });
  show(1);
})();
